import template from './template.html';

export default {
    name: 'navigationItem',
    template: template,
    props: {
        item: Object,
        wrapItem: Boolean,
    },
    data() {
        return {
            state: false,
        };
    },
    methods: {
        toggle() {
            this.state = !this.state;
        },
        show() {
            this.state = true;
        },
        hideMainMenu() {
            this.$store.commit('setMainNavState', false);
        },
    }
};